import { createAction, props } from '@ngrx/store';

import { CompanyResponseModel, Invitation, InvitationStatusType, UserV2 } from '@vi-iot/client';

export namespace GatewayInvitationsActions {
  export enum Type {
    LIST_GATEWAY_INVITATIONS = '[GATEWAY INVITATION LIST] List Gateway Invitations',
    LIST_GATEWAY_INVITATIONS_SUCCESS = '[GATEWAY INVITATION LIST] List Gateway Invitations Success',
    LIST_GATEWAY_INVITATIONS_ERROR = '[GATEWAY INVITATION LIST] List Gateway Invitations Error',
    GET_INVITER_DETAILS = '[GATEWAY INVITATION LIST] Get Inviter Details',
    GET_INVITER_DETAILS_SUCCESS = '[GATEWAY INVITATION LIST] Get Inviter Details Success',
    GET_INVITER_DETAILS_ERROR = '[GATEWAY INVITATION LIST] Get Inviter Details Error',
    GET_INVITEE_DETAILS = '[GATEWAY INVITATION LIST] Get Invitee Details',
    GET_INVITEE_DETAILS_SUCCESS = '[GATEWAY INVITATION LIST] Get Invitee Details Success',
    GET_INVITEE_DETAILS_ERROR = '[GATEWAY INVITATION LIST] Get Invitee Details Error',
    GET_INVITEE_COMPANY_DETAILS = '[GATEWAY INVITATION LIST] Get Invitee Company Details',
    GET_INVITEE_COMPANY_DETAILS_SUCCESS = '[GATEWAY INVITATION LIST] Get Invitee Company Details Success',
    GET_INVITEE_COMPANY_DETAILS_ERROR = '[GATEWAY INVITATION LIST] Get Invitee Company Details Error',
    GET_INVITER_COMPANY_DETAILS = '[GATEWAY INVITATION LIST] Get Inviter Company Details',
    GET_INVITER_COMPANY_DETAILS_SUCCESS = '[GATEWAY INVITATION LIST] Get Inviter Company Details Success',
    GET_INVITER_COMPANY_DETAILS_ERROR = '[GATEWAY INVITATION LIST] Get Inviter Company Details Error',
    FILTER_BY_STATUS = '[GATEWAY INVITATION LIST] Filter By Status',
    CLEAR_STORE = '[GATEWAY INVITATION LIST] Clear store',
  }

  export const listGatewayInvitations = createAction(
    Type.LIST_GATEWAY_INVITATIONS,
    props<{
      installationId?: number;
      customerNumber?: string;
      limit: number;
      offset: number;
      status: InvitationStatusType;
    }>()
  );

  export const listGatewayInvitationsSuccess = createAction(
    Type.LIST_GATEWAY_INVITATIONS_SUCCESS,
    props<{ invitations: Invitation[]; next: string }>()
  );

  export const listGatewayInvitationsError = createAction(Type.LIST_GATEWAY_INVITATIONS_ERROR);

  export const getInviterDetails = createAction(
    Type.GET_INVITER_DETAILS,
    props<{
      accountId: string;
    }>()
  );

  export const getInviterDetailsSuccess = createAction(
    Type.GET_INVITER_DETAILS_SUCCESS,
    props<{
      accountId: string;
      response: UserV2;
    }>()
  );

  export const getInviterDetailsError = createAction(Type.GET_INVITER_DETAILS_ERROR);

  export const getInviteeDetails = createAction(
    Type.GET_INVITEE_DETAILS,
    props<{
      accountId: string;
    }>()
  );

  export const getInviteeDetailsSuccess = createAction(
    Type.GET_INVITEE_DETAILS_SUCCESS,
    props<{
      accountId: string;
      response: UserV2;
    }>()
  );

  export const getInviteeDetailsError = createAction(Type.GET_INVITEE_DETAILS_ERROR);

  export const getInviteeCompanyDetails = createAction(
    Type.GET_INVITEE_COMPANY_DETAILS,
    props<{
      token: string;
      companyId: string;
    }>()
  );

  export const getInviteeCompanyDetailsSuccess = createAction(
    Type.GET_INVITEE_COMPANY_DETAILS_SUCCESS,
    props<{
      token: string;
      companyId: string;
      data: CompanyResponseModel;
    }>()
  );

  export const getInviteeCompanyDetailsError = createAction(Type.GET_INVITEE_COMPANY_DETAILS_ERROR);

  export const getInviterCompanyDetails = createAction(
    Type.GET_INVITER_COMPANY_DETAILS,
    props<{
      token: string;
      companyId: string;
    }>()
  );

  export const getInviterCompanyDetailsSuccess = createAction(
    Type.GET_INVITER_COMPANY_DETAILS_SUCCESS,
    props<{
      token: string;
      companyId: string;
      data: CompanyResponseModel;
    }>()
  );

  export const getInviterCompanyDetailsError = createAction(Type.GET_INVITER_COMPANY_DETAILS_ERROR);

  export const filterByStatus = createAction(
    Type.FILTER_BY_STATUS,
    props<{
      installationId?: number;
      customerNumber?: string;
      limit: number;
      offset: number;
      status: InvitationStatusType;
    }>()
  );

  export const clearStore = createAction(Type.CLEAR_STORE);
}
